<template>
  <div class="Deduction">
    <div class="border-bottom margin-top1" style="overflow: hidden;">
      <el-form :model="ruleForm" ref="ruleForm" class="demo-ruleForm" label-width="100px">

        <el-row v-if="this.str.type == 1">
        <el-form-item label="选择分公司" prop="staffvalue">
          <el-select v-model="ruleForm.branch" placeholder="请选择" filterable @change="selectbranch">
            <el-option
              v-for="item in selectList"
              :key="item.value"
              :label="item.companyName"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择子公司" prop="staffvalue">
          <el-select v-model="ruleForm.subsidiary" placeholder="请选择" filterable @change="selectsubsidiary">
            <el-option
              v-for="item in selectList1"
              :key="item.value"
              :label="item.companyName"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        </el-row>

        <el-form-item label="选择子公司" prop="staffvalue" v-if="this.str.type == 2">
          <el-select v-model="ruleForm.subsidiary" placeholder="请选择" filterable  @change="selectsubsidiary1">
            <el-option
              v-for="item in selectList1"
              :key="item.value"
              :label="item.companyName"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="费用类型" prop="staffvalue">
          <el-select v-model="ruleForm.staffvalue" placeholder="请选择">
            <el-option
              v-for="item in optionStaff"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始日期" prop="starttime">
          <el-date-picker v-model="ruleForm.starttime" type="date" placeholder="选择开始日期" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期" prop="endtime">
          <el-date-picker v-model="ruleForm.endtime" type="date" placeholder="选择结束日期" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        <el-form-item label prop="searchString" style="width: 40%;">
            <el-input v-model="ruleForm.searchString" placeholder="相关单据号、订单ID、订单号" style="width: 70%;" ></el-input>
            <el-button type="primary" style="margin-left: 5px;" class="search" @click="search2">搜索</el-button>
            <el-button type="primary" class="search" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <el-row class="color border-bottom" type="flex" justify="space-around" :gutter="20">
        <el-col :span="8">列表总计金额：可用余额：{{price.buckleBalance1}} 实际余额：{{price.balance1}}</el-col>
        <el-col :span="8">当前余额：可用余额：{{companyInfo.buckleBalance}} 实际余额：{{companyInfo.balance}}</el-col>
      </el-row>
    </div>
    <div class="margin-top1">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column align="center" prop="documentNo" label="相关单据号" width="200"></el-table-column>
        <el-table-column align="center" prop="orderId" label="订单ID" width="200"></el-table-column>
        <el-table-column align="center" prop="amazonOrderId" label="订单号" width="200"></el-table-column>
        <el-table-column align="center" label="费用类型">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 1">充值</span>
            <span v-if="scope.row.type == 2">运费预扣</span>
            <span v-if="scope.row.type == 3">收件费用</span>
            <span v-if="scope.row.type == 4">退件费用</span>
            <span v-if="scope.row.type == 5">分装费用</span>
            <span v-if="scope.row.type == 6">合装费用</span>
            <span v-if="scope.row.type == 7">包材费用</span>
            <span v-if="scope.row.type == 8">仓储费用</span>
            <span v-if="scope.row.type == 9">出库操作费</span>
            <span v-if="scope.row.type == 10">预扣运费回退</span>
            <span v-if="scope.row.type == 11">运费实扣</span>
            <span v-if="scope.row.type == 12">平台费用扣除</span>
            <span v-if="scope.row.type == 13">售后回退</span>
            <span v-if="scope.row.type == 14">快递查询费用</span>
            <span v-if="scope.row.type == 15">商城订单扣费</span>
            <span v-if="scope.row.type == 16">商城订单扣费回退</span>
            <span v-if="scope.row.type == 17">运费实扣之后作废回退</span>
            <span v-if="scope.row.type == 18">操作费回退</span>
            <span v-if="scope.row.type == 19">合装费回退</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="withholdingExpenses1" label="费用（可用）" width="110"></el-table-column>
        <el-table-column align="center" prop="actualExpenses1" label="费用（实际）" width="110"></el-table-column>
        <el-table-column align="center" prop="createTime" label="扣款时间"></el-table-column>
        <el-table-column align="center" prop="volumeWeight" label="材积重" width="100"></el-table-column>
        <el-table-column align="center" prop="weight" label="称重重量" width="100"></el-table-column>
        <el-table-column align="center" prop="billingWeight" label="计费重" width="100"></el-table-column>
        <el-table-column align="center" prop="packId" label="包材明细"></el-table-column>
      </el-table>
    </div>
    <div class="page">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[50, 100, 200, 400]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            ></el-pagination>
        </div>
  </div>
</template>
<script>
import { ajaxPost, Baseurl } from "../../../../api/api/api";
export default {
  name: "Statistics",
  props: ['dateData'],
  data() {
    return {
      str:"",
      tableData: [],
      price:"",
      companyInfo:"",
      company_id:"",
      type:"",

      currentPage: 1,
      pagesize: 50,
      size: 50,
      total: 0,
      selectList:[],
      selectList1:[],

      optionStaff: [
        {
          value: "1",
          label: "充值"
        },
        {
          value: "2",
          label: "运费预扣"
        },
        {
          value: "3",
          label: "收件费用"
        },
        {
          value: "4",
          label: "退件费用"
        },
        {
          value: "5",
          label: "分装费用"
        },
        {
          value: "6",
          label: "合装费用"
        },
        {
          value: "7",
          label: "包材费用"
        },
        {
          value: "8",
          label: "仓储费用"
        },
        {
          value: "9",
          label: "出库操作费"
        },
        {
          value: "10",
          label: "预扣运费回退"
        },
        {
          value: "11",
          label: "运费实扣"
        },
        {
          value: "12",
          label: "平台费用扣除"
        },
        {
          value: "13",
          label: "售后回退"
        },
        {
          value: "14",
          label: "快递查询费用"
        },
        {
          value: "15",
          label: "商城订单扣费"
        },
        {
          value: "16",
          label: "商城订单扣费回退"
        },
        {
          value: "17",
          label: "运费实扣之后作废回退"
        },
        {
          value: "18",
          label: "操作费回退"
        },
        {
          value: "19",
          label: "合装费回退"
        },
        {
          value: "20",
          label: "买家账号费用"
        }
      ],
      ruleForm: {
        staffvalue: "", //选择员工
        starttime: "", //开始时间
        endtime: "", //结束时间
        searchString:"",
        branch:"",//分公司
        subsidiary:"",//子公司
      },
    };
  },
  mounted() {},
  created() {
    this.str = JSON.parse(localStorage.getItem("role"));
    this.companyList()
    this.company_id = this.str.company_id
    this.type = this.str.type
    if(this.str.type !== 1){
      this.search()
    }
    if(this.str.type == 2){
      this.SelectAjax2()
    }
  },
  watch: {
    dateData: {
      handler(newVal) {
        if (newVal) {
          this.ruleForm.starttime = newVal.startTime
          this.ruleForm.endtime = newVal.endTime
          // this.search();
        }
      },
      immediate: true
    }
  },
  methods: {
    search2(){
      this.currentPage = 1
      this.search()
    },
    search(){
      console.log(this.company_id)
      var obj = {
          companyId:this.company_id,
          type:this.ruleForm.staffvalue,
          searchVal:this.ruleForm.searchString,
          beginDate:this.ruleForm.starttime,
          endDate:this.ruleForm.endtime,
          page:this.currentPage,
          size:this.size
      };
      ajaxPost(Baseurl + "financesController/selectDeductionDetailsInfo", obj).then(res => {
          this.tableData = res.data.data.pageInfo.list;
          this.total = res.data.data.pageInfo.total
          this.price = res.data.data
      });
      this.getCompanyInfo();
    },
    companyList(){
      ajaxPost(Baseurl + "roleController/selectNextInfoByRid", {
                companyId: this.str.company_id,
                rid:this.str.rid,
                system:this.str.system
      }).then(res => {
                if(res.data.code == 200){
                    this.selectList = res.data.data.next
                    this.ruleForm.subsidiary = ""
                    // console.log(res.data.data.next)
                }
      });
    },
    selectbranch(val){
      this.company_id = val.company_id
      this.type = val.type

      // console.log(this.company_id)
      ajaxPost(Baseurl + "roleController/selectNextInfoByRid", {
                companyId: val.company_id,
                rid:val.rid,
                system:val.system
      }).then(res => {
                if(res.data.code == 200){
                    this.selectList1 = res.data.data.next
                }
      });
    },
    SelectAjax2(){
      ajaxPost(Baseurl + "roleController/selectNextInfoByRid", {
        companyId: this.str.company_id,
        rid:this.str.rid,
        system:this.str.system
      }).then(res => {
        if(res.data.code == 200){
            this.selectList1 = res.data.data.next
        }
      });
    },
    selectsubsidiary(val){
      this.company_id = val.company_id
      this.type = val.type
    },
    selectsubsidiary1(val){
      this.company_id = val.company_id
      this.type = val.type
    },
    getCompanyInfo() {
              var obj = {
                id: this.company_id,
                type:this.type
              }
            console.log(obj)
            ajaxPost(Baseurl + "companyController/selectCompanyByCompanyId", obj).then(res => {
                if(res.data.code == 200){
                    this.companyInfo = res.data.data
                }
            });
    },
    startTime(val) {
        var d = new Date(val);
        var datetime = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate() + " 00:00:00";
        this.ruleForm.starttime = datetime;
        // console.log(this.ruleForm.startTimeString);
    },
    endTime(val) {
        var d = new Date(val);
        var datetime = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate() + " 23:59:59";
        this.ruleForm.endtime = datetime;
        // console.log(this.ruleForm.endTimeString);
    },
    reset(){
      this.ruleForm.staffvalue = ""
      this.ruleForm.searchString = ""
      this.ruleForm.starttime = ""
      this.ruleForm.endtime = ""
      
      if(this.str.type == 1){
        this.ruleForm.branch = ""
        this.ruleForm.subsidiary = ""
        this.selectList1 = []
        this.company_id = this.str.company_id
        this.type = this.str.type
      }else if(this.str.type == 2){
        this.ruleForm.subsidiary = ""
        this.company_id = this.str.company_id
        this.type = this.str.type
      }
      this.search();
    },
    handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
        this.size = val;
        this.search()
    },
    handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.currentPage = val;
        this.search()
    },
  }
};
</script>

<style lang="scss" scoped>
/deep/ {
  .el-table {
    font-size: 12px;
  }
  .el-table td,
  .el-table th {
    padding: 7px 0;
  }
}
.Deduction {
  margin-bottom:50px ;
  width: 98%;
  overflow: hidden;
  .Deduction-content {
    .el-form-item {
      overflow: hidden;
      width: 20%;
      margin-bottom: 18px;
      float: left;
    }
    .Reportform_tiem {
      overflow: hidden;
      border-top: 1px solid #eee;
      padding: 15px 0;
      .search-result-text {
        font-size: 14px;
        color: #606266;
        padding: 0;
      }
      .el-radio-group {
        display: inline-block;
        line-height: 1;
        vertical-align: middle;
        font-size: 0;
        margin-left: 20px;
      }
    }
    .paging {
      width: 40%;
      margin: 20px auto;
    }
  }
}
.page{
    position: fixed;
    width: 86%;
    bottom: 0;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
}
.color {
  color: #434448;
  line-height: 40px;
}
</style>
